import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Etwas ist schiefgelaufen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const fileUrl = (id) => `${API}/files/${id}/content`;
export const posterUrl = (f) => (f?.has_poster ? `${fileUrl(f.id)}?variant=poster` : undefined);
export const playUrl = (f) => (f?.has_preview ? `${fileUrl(f.id)}?variant=preview` : fileUrl(f.id));

export const STATUS = {
  draft: { label: "Entwurf", cls: "bg-slate-800 text-slate-300 border-slate-700" },
  pending_approval: { label: "Wartet auf Freigabe", cls: "bg-amber-950/60 text-amber-400 border-amber-800/50" },
  changes_requested: { label: "Änderung angefordert", cls: "bg-orange-950/60 text-orange-400 border-orange-800/50" },
  rejected: { label: "Gesperrt", cls: "bg-rose-950/60 text-rose-400 border-rose-800/50" },
  approved: { label: "Freigegeben", cls: "bg-emerald-950/60 text-emerald-400 border-emerald-800/50" },
  scheduled: { label: "Eingeplant", cls: "bg-blue-950/60 text-blue-400 border-blue-800/50" },
  published: { label: "Veröffentlicht", cls: "bg-teal-950/60 text-teal-300 border-teal-800/50" },
};

export const PLATFORMS = {
  instagram: { label: "Instagram", color: "#E4405F" },
  tiktok: { label: "TikTok", color: "#25F4EE" },
  youtube: { label: "YouTube Shorts", color: "#FF0000" },
  facebook: { label: "Facebook", color: "#1877F2" },
  linkedin: { label: "LinkedIn", color: "#0A66C2" },
};

export const CONTENT_TYPES = { photo: "Foto", video: "Video / Reel", carousel: "Karussell" };

export const FORMAT_BADGE = {
  video: { label: "Video-Reel", cls: "bg-teal-500 text-slate-950" },
  photo: { label: "Bildbeitrag", cls: "bg-amber-500 text-slate-950" },
  carousel: { label: "Karussell", cls: "bg-sky-500 text-slate-950" },
};

export const DAY_NAMES = { Mo: "Montag", Di: "Dienstag", Mi: "Mittwoch", Do: "Donnerstag", Fr: "Freitag", Sa: "Samstag", So: "Sonntag" };

export const MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export const emitPostsChanged = () => window.dispatchEvent(new Event("posts-changed"));

export function pollAiPending(clientId) {
  let tries = 0;
  const tick = async () => {
    tries += 1;
    const r = await api.get("/posts", { params: { client_id: clientId } }).catch(() => null);
    emitPostsChanged();
    if (r && r.data.some((p) => p.ai_pending) && tries < 80) setTimeout(tick, 4000);
  };
  setTimeout(tick, 4000);
}

export const DAY_KEYS = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
